export default "__VITE_ASSET__DugTcrZf__"